const TRANSPARENT = 'rgba(0, 0, 0, 0)';

export const resolveBackground = (el: HTMLElement): string => {
  let node: HTMLElement | null = el.parentElement;

  while (node) {
    const bg = getComputedStyle(node).backgroundColor;

    if (bg !== TRANSPARENT && bg !== 'transparent') {
      return bg;
    }

    node = node.parentElement;
  }

  return 'white';
};
